<template>
    <div class="pages" v-cloak>
        <headerView :show-bg="true"></headerView>

        <div class="loadview">
            <div class="component person-nav">
                <div class="van-sticky">
                    <div class="w1280 goods-cat-page">
                        <div class="goods-cat-top" v-loading="categoryList.length == 0">
                            <div class="goods-cat-top-head">
                                <h3 class="goods-cat-top-title">产品系列</h3>
                                <p class="goods-cat-top-subtitle">创新实力产品，品牌成就未来</p>
                            </div>
                            <div class="goods-cat-top-list">
                                <div v-for="cat in categoryList" :key="cat.id" class="goods-cat-top-item"
                                    :class="{ active: currentCategoryId === cat.id }" @click="clickCategory(cat.id)">
                                    <div class="goods-cat-top-img">
                                        <img :src="cat.imgUrl" alt="" />
                                    </div>
                                    <div class="goods-cat-top-text">
                                        <p class="goods-cat-top-name">{{ cat.categoryName }}</p>
                                        <!-- <p class="goods-cat-top-desc">{{ cat.desc }}</p> -->
                                    </div>
                                    <div class="goods-cat-top-back"></div>
                                    <!-- <span class="goods-cat-top-arrow" v-if="currentCategoryId === cat.id"></span> -->
                                </div>
                            </div>
                        </div>

                        <div class="goods-cat-main" v-loading="listLoading" v-if="stateSche == 0 || stateSche == 1">
                            <div class="goods-cat-grid">
                                <div v-for="item in goodsList" :key="item.spuId" class="goods-cat-card"
                                    @click="clickDetail(item)">
                                    <div class="goods-cat-card-img">
                                        <img v-if="item.masterUrl" :src="item.masterUrl" alt="" />
                                    </div>
                                    <div class="column">
                                        <p class="goods-cat-card-title">{{ item.name }}</p>
                                        <p class="goods-cat-card-desc">{{ item.subTitle }}</p>
                                        <button class="goods-cat-card-btn">查看详情</button>
                                    </div>
                                </div>
                            </div>

                            <pagination style="text-align: center;" v-show="total > 0" :total="total"
                                :page.sync="listQuery.Page" :limit.sync="listQuery.Limit"
                                @pagination="handlePagination" />
                        </div>

                        <div class="nodata" v-if="stateSche == 2 || stateSche == 3">{{ $t('nodata') }}</div>
                    </div>
                </div>
            </div>
        </div>


        <footView></footView>
    </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { mapGetters } from "vuex";
import { getCategorySpu, getSpuList } from "@/request/api";


export default {
    name: "categoryList",
    components: { Pagination },
    data() {
        return {
            currentCategoryId: null,
            goodsList: [],
            stateSche: 0,
            listLoading: false,
            listQuery: {
                Page: 1,
                Limit: 15
            },
            total: 0,
        }
    },
    computed: {
        ...mapGetters({ categoryList: 'categoryList' },),
    },
    watch: {
        categoryList: {
            handler(newVal, oldVal) {
                
                if (newVal && newVal.length) {
                    this.clickCategory(newVal[0].id);
                }
            },
            deep: true, // 开启深度监听
            immediate: false
        }

    },
    mounted() {
        if (this.categoryList.length && !this.currentCategoryId) {
            this.clickCategory(this.categoryList[0].id);
        }
    },
    created() { },
    methods: {
        clickCategory(id) {
            this.currentCategoryId = id;
            this.getDataList();
        },
        clickDetail(item) {
            this.$router.push("/goods/detail?id=" + item.spuId)
        },
        // getDataList() {
        //     let that = this;
        //     that.stateSche = 1;
        //     that.listLoading = true;
        //     getCategorySpu("categoryId=" + that.currentCategoryId).then((res) => {
        //         that.listLoading = false;
        //         if (res.code == 200) {
        //             if (res.data != null && res.data.length > 0) {
        //                 that.goodsList = res.data;

        //             } else {
        //                 that.goodsList = null;
        //                 that.stateSche = 2;
        //             }
        //         } else if (res.code == 204) {
        //             that.goodsList = null;
        //             that.stateSche = 2;
        //         } else {
        //             that.goodsList = null;
        //             that.stateSche = 3;
        //         }
        //     });
        // },

        getDataList() {
            let that = this;
            that.stateSche = 1;
            that.listLoading = true;
            let para = {
                pageParm: {
                    page: that.listQuery.Page,
                    limit: that.listQuery.Limit,
                    keyword: "",
                    field: "",
                    sort: 0,
                    orderByFields: "spu.Id DESC"
                },
                categoryId: that.currentCategoryId

            };
            getSpuList(para).then((res) => {
                that.listLoading = false;

                if (res.code == 200) {
                    that.goodsList = res.data.data;
                    that.total = res.data.dataCount;
                    that.stateSche = that.goodsList.length ? 0 : 2;
                } else if (res.code == 204) {
                    that.goodsList = null;
                    that.stateSche = 2;
                } else {
                    that.goodsList = null;
                    that.stateSche = 3;
                }
            });
        },
        
        //分页回调
        handlePagination(data) {
            var that = this;
            if (data) {
                that.listQuery.Page = data.page;
                that.listQuery.Limit = data.limit;
                that.getDataList();
            }
        },

        jumpDetail(item) {
            this.$router.push("/goods/detail?id=" + item.spuId)
        }
    }
};
</script>

<style scoped lang="scss">
.goods-cat-page {
    min-height: 82vh;
    display: flex;
    flex-direction: column;
    padding-top: 24px;
    padding-bottom: 48px;
}

.nodata {
    background-color: transparent;
}

.w1280 {
    max-width: 1280px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0 16px;
}


.goods-cat-top {
    background: #fff;
    border-radius: 12px;
    padding: 20px 24px;
    margin-bottom: 24px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.04);
}

.goods-cat-top-head {
    margin-bottom: 16px;
}

.goods-cat-top-title {
    font-size: 22px;
    font-weight: bold;
    color: #333;
    line-height: 1.4;
    margin: 0 0 5px;
    // padding-left: 12px;
    // border-left: 4px solid #e60012;
}

.goods-cat-top-subtitle {
    font-size: 14px;
    color: var(--main-color);
    line-height: 1.4;
    margin: 0;
}

.goods-cat-top-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
}


.goods-cat-top-item {
    position: relative;
    border: 2px solid transparent;
    border-radius: 10px;
    cursor: pointer;
    background: #fafafa;
    transition: all 0.2s;
    overflow: hidden;

    &:hover {
        // border-color: #e60012;
        background: #fff;

        .goods-cat-top-back {
            display: none;
        }
    }

    &.active {
        border-color: #e60012;
        background: #fff;

        .goods-cat-top-back {
            display: none;
        }
    }
}



.goods-cat-top-img {
    width: 100%;
    height: 140px;
    flex: none;
    overflow: hidden;
    background: #f0f0f0;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
}

.goods-cat-top-text {
    flex: 1;
    min-width: 0;
    padding: 10px 8px;
}

.goods-cat-top-name {
    font-size: 15px;
    font-weight: 500;
    color: #333;
    line-height: 1.4;
    margin: 0 0 4px;
}

.goods-cat-top-desc {
    font-size: 12px;
    color: #999;
    line-height: 1.4;
    margin: 0;
}

.goods-cat-top-back {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.3);
}

// .goods-cat-top-arrow {
//     position: absolute;
//     left:50%;
//     bottom: -10px;
//     background-color: #fff;
//     width: 20px;
//     height: 20px;
//     border-style: solid;
//     border-width: 2px;
//     border-color: transparent transparent #e60012 #e60012;
//     transform: rotate(-45deg);
//     margin-left: -10px;
// }

.goods-cat-main {
    flex: 1;
    min-width: 0;
}

.goods-cat-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
    margin-bottom: 32px;
}

.goods-cat-card {
    background: #fff;
    border-radius: 10px;
    padding: 14px;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 22px rgba(0, 0, 0, 0.2);
    }
}

.goods-cat-card-img {
    width: 100%;
    height: 140px;
    overflow: hidden;
    border-radius: 6px;
    background: #f5f5f5;
    margin-bottom: 8px;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
}

.goods-cat-card-title {
    font-size: 15px;
    font-weight: bold;
    color: #333;
    line-height: 1.4;
    margin: 0 0 4px;
}

.goods-cat-card-desc {
    font-size: 12px;
    color: #666;
    line-height: 1.5;
    margin: 0 0 12px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 40px;
}

.goods-cat-card-btn {
    width: 80px;
    background: #e60012;
    color: #fff;
    border: none;
    border-radius: 16px;
    padding: 8px 0;
    line-height: 1;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s;
    align-self: flex-end;

    &:hover {
        opacity: 0.9;
    }
}

@media screen and (max-width: 1100px) {

    // .goods-cat-top-list {
    //     grid-template-columns: repeat(2, 1fr);
    // }
    .goods-cat-top-img {
        height: 80px;
    }

    .goods-cat-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media screen and (max-width: 769px) {

    .goods-cat-page {
        padding-top: 0;
        min-height: 60vh;

        .goods-cat-top-subtitle {
            font-size: 16px;
        }

        .goods-cat-top {
            padding: 16px 2px;
            margin-bottom: 18px;
        }

        .goods-cat-top-list {
            gap: 12px;
        }

        .goods-cat-top-img {
            height: auto;
        }

        .goods-cat-top-name {
            font-size: 18px;
        }

        .goods-cat-grid {
            grid-template-columns: repeat(3, 1fr);
        }

        .goods-cat-card {
            padding: 0 0 10px;

            .column {
                padding: 0 8px;
            }
        }

        .goods-cat-card-title {
            font-size: 18px;
        }

        .goods-cat-card-desc {
            font-size: 14px;
        }


    }

}
</style>
